var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen",attrs:{"id":"app"}},[(!_vm.showErrorMessage)?_c(_vm.layout,{tag:"component"},[_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1):_c('internet-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }